import type {
	BrandDiscoveryQuestion,
	BrandDiscoveryRun
} from '$lib/apis/content-factory/onboarding';

import {
	projectOnboardingDiscoveryQuestionContinuation,
	type OnboardingDiscoveryQuestionContinuationV1
} from './onboardingDiscoveryQuestionContinuation';

export type OnboardingPendingQuestionScope = Readonly<{
	stateId: string;
	workspaceId: string;
	brandId: string;
	discoveryRunId: string;
}>;

export class OnboardingPendingQuestionAuthorityError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'OnboardingPendingQuestionAuthorityError';
	}
}

export const projectScopedOnboardingPendingQuestion = ({
	scope,
	run,
	questions
}: {
	scope: OnboardingPendingQuestionScope;
	run: BrandDiscoveryRun;
	questions: BrandDiscoveryQuestion[];
}): OnboardingDiscoveryQuestionContinuationV1 | null => {
	if (
		run.run_id !== scope.discoveryRunId ||
		run.state_id !== scope.stateId ||
		run.workspace_id !== scope.workspaceId ||
		run.brand_id !== scope.brandId
	) {
		throw new OnboardingPendingQuestionAuthorityError(
			'Pending onboarding discovery run conflicts with its authoritative scope'
		);
	}
	if (
		questions.some(
			(question) =>
				question.run_id !== scope.discoveryRunId ||
				question.workspace_id !== scope.workspaceId ||
				question.brand_id !== scope.brandId
		)
	) {
		throw new OnboardingPendingQuestionAuthorityError(
			'Pending onboarding question rows conflict with their authoritative scope'
		);
	}
	const continuation = projectOnboardingDiscoveryQuestionContinuation({ run, questions });
	if (!continuation && questions.some((question) => question.status === 'pending')) {
		throw new OnboardingPendingQuestionAuthorityError(
			'Pending onboarding question rows are malformed'
		);
	}
	if (
		continuation &&
		(continuation.runRef !== scope.discoveryRunId ||
			continuation.workspaceRef !== scope.workspaceId ||
			continuation.brandRef !== scope.brandId)
	) {
		throw new OnboardingPendingQuestionAuthorityError(
			'Pending onboarding question conflicts with its authoritative scope'
		);
	}
	return continuation;
};
